<template>
  <el-select
    v-model="valueBackup"
    placeholder="请选择课卡"
    filterable
    clearable
    @change="handleChange"
    :style="`width: ${width}`"
  >
    <el-option
      v-for="item in list"
      :key="item.id"
      :label="`${item.card_type_name} - ${item.card_name}`"
      :value="item.id"
    >
      <span style="float: left">{{ item.card_type_name }}</span>
      <span style="float: right; color: #8492a6; font-size: 13px">
        {{ item.card_name }}，
        <span v-if="item.is_number_limit">剩余 {{ item.expire_number | toYuan }} 次，</span>
        <span v-if="item.expire_time">{{ item.expire_time | timeToYmdHi }} 到期</span>
        <span v-else>未开卡</span>
      </span>
    </el-option>
  </el-select>
</template>

<script>
import { index } from '@/api/card';

export default {
  props: {
    value: [Number, String],
    studentId: [Number, String],
    width: {
      type: String,
      default: '100%',
    },
  },
  data: () => ({
    valueBackup: '',
    list: [],
  }),
  watch: {
    value(value) {
      if (value === this.valueBackup) return;
      this.valueBackup = +value || '';
    },
    valueBackup(valueBackup) {
      if (valueBackup === (+this.value || '')) return;
      this.$emit('input', valueBackup);
    },
    studentId(studentId) {
      if (studentId) this.getList(studentId);
    },
  },
  methods: {
    async getList(student_id) {
      if (!student_id) return;

      const { isError, data } = await index({ student_ids: [student_id] });
      if (isError) return;

      this.list = data.list;
    },
    handleChange(valueBackup) {
      const card = this.list.find(card => card.id === valueBackup);
      this.$emit('change', card);
    },
  },
  beforeMount() {
    this.valueBackup = +this.value || '';
    this.getList(this.studentId);
  }
};
</script>

